import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { ScStep } from '../../models';
import { ScStepService } from './sc-step.service';

@Injectable()
export class ScCanActivateStepService implements CanActivateChild {
  constructor(private _stepService: ScStepService, private _router: Router, private _route: ActivatedRoute) {}

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (!this._stepService.isInitialized) {
      this._stepService.isInitialized = true;
      return of(true);
    }

    return this._stepService.getSteps().pipe(
      map((steps: ScStep[]) => {
        if (!steps.length) {
          return true;
        }

        const currentStepIndex = steps.findIndex(s => s.route === route.routeConfig.path);
        const currentStep = steps[currentStepIndex];

        const prviousStep = steps[currentStepIndex - 1];

        if (currentStep.done) {
          return false;
        }

        return prviousStep && prviousStep.form ? prviousStep.form.valid : true;
      })
    );
  }
}
